import { config } from "./_config"
import { AwsApiService } from './_baseService';

export const postData = async({ path, data }) => {
    let responseCode = null;
    let responseData = { httpStatus: null, error: {} };
    try {
        const { status:responseCode } = await AwsApiService.post(`${path}`, data, {
            headers: { 
                'Content-Type': 'application/json',
                'x-api-key': config.apiGatewayKey }
        });
        responseData = { httpStatus: responseCode };
    } catch (error) {
        responseData = { httpStatus: responseCode, error:error };
        console.error(error);
    }
    return { responseData };
}

export default postData;